import React, { useState } from 'react'
import './ExportMenu.css'
import ExportDialog from './ExportDialog'
import MedModal from '../../../../shared/MedModal'
import { useStructureExclude } from '../../../../shared/contexts/StructureContext'

// Function based component, represents the export button, which is inserted
// in the selected data table. When this button is pressed, the export dialog
// compontent is shown in a react modal viewz
// Added 'children' prop for custom button/trigger element.
function ExportMenu({ selectedData, text, children }) {
  // Initialize the modal state
  const [showModal, setModalState] = useState(false)
  
  // Handler to open the modal
  const openModal = () => setModalState(true)
  // Handler to close the modal
  const closeModal = () => setModalState(false)


  // Modify selectedData to have display name as key
  const attributeMapping = {};
  const variableCategories = useStructureExclude()
  const sortedVariableCategories = {};

  for (const category in variableCategories) {
    // Sort each category's variables by `data-value`
    sortedVariableCategories[category] = [...variableCategories[category]].sort((a, b) => {
      return a['data-value'].localeCompare(b['data-value']);
    });
  }

  // Iterate through variableCategories to build the attributeMapping
  for (const category in variableCategories) {
    for (const varIndex in variableCategories[category]) {
      const variable = variableCategories[category][varIndex];
      const attributeName = variable['data-key'];
      const nicerName = variable['data-value'];

      attributeMapping[attributeName] = nicerName;
    }
  }

  // Use the attributeMapping to transform selectedData
  const transformedData = selectedData.map(item => {
    const transformedItem = {};

    for (const attributeName in item) {
      const nicerName = attributeMapping[attributeName] || attributeName;
      transformedItem[nicerName] = item[attributeName];
    }

    return transformedItem;
  });

  // Decide what to render as the trigger: either children or the default button.
  let triggerElement;
  if (children) {
    // If children are provided, clone the element and inject the onClick handler.
    // This allows you to use your custom button structure.
    triggerElement = React.cloneElement(children, {
      onClick: openModal
    });
  } else {
    // Default button rendering remains if no children are provided.
    triggerElement = (
      <button
        className="med-primary-solid med-bx-button med-data-button"
        onClick={openModal}
      >
        <i className="bx bxs-file-export med-button-image"></i>{text}
      </button>
    );
  }

  return (
    <>
      {/* Render the selected trigger element */}
      {triggerElement}

      <MedModal showModal={showModal} closeModal={closeModal}>
        <ExportDialog data={transformedData} variableCategories={sortedVariableCategories} attributeMapping={attributeMapping} onClose={closeModal} />
      </MedModal>
    </>
  )
}

export default ExportMenu